import { Component } from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {Title} from "@angular/platform-browser";
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  //templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 
  domain;  titleIcon = 'Transport';
  constructor(
    @Inject(DOCUMENT) private document: any,
    private titleService:Title
  ) {
    this.domain = this.document.location.hostname;
    
    if(this.domain=='cargolean.com'){
      this.titleService.setTitle("cargoLEAN - Transport ERP");
      this.document.getElementById('appIcon').setAttribute('href','assets/img/favicon.png');
    }else{
      this.titleService.setTitle("cargoLEAN - Transport ERP");
      this.document.getElementById('appIcon').setAttribute('href','assets/img/favicon.png');
      //this.document.getElementById('appIcon').setAttribute('href','assets/img/favicon_viatpro.png');
    }
  }

}
